'use strict';
var util = require('../util');
var async = require('../async');
var core = require('../core');

module.exports = {
  appVersion: '7.9.1',
  
  setNavigationBarHidden: util.actionMapping('setNavigationBarHidden'),

  chooseImage: function(opt) {
    opt = opt || {};
    opt.count = (!opt.count || opt.count > 9 || opt.count < 1) ? 9 : opt.count;
    this._send('chooseImage', opt);
  },
  uploadImage: function(opts) {
    var success = opts.success;
    var fail = opts.fail;
    var handle = opts.handle;
    var ua = this.getUA();
    var self = this;
    if (opts.localId || opts.localIds) {
      if (core.Semver.gte(ua.adapterVersion || ua.appVersion, '7.9.1')) {
        if (opts.localIds) {
          (function(ids) {
            var picKeys = {};
            var photoInfos = [];
            async.mapSeries(ids, function(id, done){
              self._send('uploadPhoto', {
                localId: id,
                success: function(e){
                  picKeys[id] = e.picKey;
                  photoInfos.push({
                    localId: id,
                    picKey: e.picKey//FIX BUG, What 'picKey' mean?
                  });
                  done(null);
                },
                fail: function(e){
                  done(e);
                }
              });
            }, function(e){
              if(e){
                fail && fail(e);
              }else{
                success && success({
                  picKeys: picKeys,
                  photoInfos: photoInfos
                });
              }
            });
          })(opts.localIds);
        } else {
          this._send('uploadPhoto', opts);
        }
      } else {
        fail({
          errMsg: 'ERR_NOT_IMPLEMENTED'
        });
      }
    } else {
      this._sendMessage('uploadImage', opts, function(result) {
        var status = result.status;
        if (status == 'fail') {
          fail && fail(result);
          return;
        } else {
          handle && handle(result);
        }
      });
    }
  },
};


//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@dp/dpapp/lib/patch/patch-7.9.1.js
// module id = 551
// module chunks = 0